import ResourceDrawer from './ResourceDrawer';

const resourceDrawerRoute = {
  path: '#/resource/:id',
  component: ResourceDrawer
};

export default resourceDrawerRoute;
